import { render, staticRenderFns } from "./OutboundRemarkForm.vue?vue&type=template&id=9b723ce6&scoped=true"
import script from "./OutboundRemarkForm.vue?vue&type=script&lang=js"
export * from "./OutboundRemarkForm.vue?vue&type=script&lang=js"
import style0 from "./OutboundRemarkForm.vue?vue&type=style&index=0&id=9b723ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b723ce6",
  null
  
)

export default component.exports